import React,{ useEffect, useState } from "react";
import { useLocation, useNavigate  } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import { Box, Typography, List, ListItem, Divider, Button, Chip } from "@mui/material";
export default function MyOrder() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
const cartIdFromQuery = searchParams.get("cartId");
const navigate = useNavigate();

const cartId =
  cartIdFromQuery ||
  location.state?.cartId ||
  sessionStorage.getItem("cartId");

  const [items, setItems] = useState([]);

  console.log("Cart ID from query params:", cartId);

  useEffect(() => {
    const fetchOrderedItems = async () => {
      if (!cartId) {
        console.warn("No cartId found. Cannot fetch ordered items.");
        return;
      }

      try {
        // ✅ Query the collection where cartId field matches
        const q = query(collection(db, "carts"), where("cartId", "==", cartId));
        const snapshot = await getDocs(q);

        console.log("Snapshot docs count:", snapshot.size);
snapshot.forEach(doc => {
  console.log("Doc ID:", doc.id, "Data:", doc.data());
});
        if (!snapshot.empty) {
  let allItems = [];

  snapshot.forEach(doc => {
    const data = doc.data();

    /*const orderedItems = (data.items || []).filter(
      item => item.status === "Ordered"
    );*/

    const validStatuses = ["Ordered", "Confirmed", "Preparing", "Ready", "Served"];

const orderedItems = (data.items || []).filter(
  item => validStatuses.includes(item.status)
);
    allItems = [...allItems, ...orderedItems];
  });

  console.log("All ordered items:", allItems);
  setItems(allItems);
} else {
  console.warn("No cart found with cartId:", cartId);
  setItems([]);
}
      } catch (error) {
        console.error("Error fetching cart document:", error);
      }
    };

    fetchOrderedItems();
  }, [cartId]);

  

return (
  <Box sx={{ maxWidth: 500, margin: "0 auto", mt: 4 }}>
    {/* 🔥 Heading */}
    <Typography
      variant="h4"
      sx={{
        fontWeight: "bold",
        mb: 3,
        textAlign: "center",
        color: "primary.main"
      }}
    >
      Ordered Items
    </Typography>

    {items.length === 0 ? (
      <Typography
        variant="body1"
        sx={{ textAlign: "center", color: "text.secondary" }}
      >
        No items found.
      </Typography>
    ) : (
     <List sx={{ bgcolor: "background.paper", borderRadius: 2 }}>
  {items.map((item, idx) => (
    <React.Fragment key={idx}>
      <ListItem
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 1.5
        }}
      >
        {/* Left: Name + Qty */}
        <Typography sx={{ fontWeight: "bold" }}>
          {item.name} ({item.quantity})
        </Typography>

        {/* Right: Price + Status */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            sx={{ fontWeight: "bold", color: "success.main" }}
          >
            ₹{item.totalPrice.toFixed(2)}
          </Typography>

          <Chip
            label={item.status}
            size="small"
            color={
              item.status === "Ordered"
                ? "primary"
                : item.status === "Preparing"
                ? "warning"
                : item.status === "Served"
                ? "success"
                : "default"
            }
            variant="outlined"
          />
        </Box>
      </ListItem>

      {idx < items.length - 1 && <Divider />}
    </React.Fragment>
  ))}
</List>
    )}
    <Box sx={{ textAlign: "center", mt: 3 }}>
  <Button
    variant="contained"
    color="primary"
    onClick={() => {
      navigate(
        `/customer/menu?code=${searchParams.get("code")}&unit=${searchParams.get("unit")}&id=${searchParams.get("id")}&serviceArea=${searchParams.get("serviceArea")}`
      );
    }}
  >
    Go to Menu
  </Button>
</Box>
  </Box>
);
}